<template>
  <DataList
    title="Бонуси"
    resource="bonuses"
    :columns="columns"
    :get-items-fn="getBonuses"
    :search-label="'Пошук за назвою клієнта'"
  />
</template>

<script>
import * as bonusesApi from "@/backend/bonusesApi.js";

export default {
  data: () => ({
    columns: [
      { title: "id", name: "id", dataPath: "id" },
      { title: "Дата", name: "date", dataPath: "date" },
      { title: "Клієнт", name: "client", dataPath: "client.title", rowType: "wide", width: 400 },
      {
        title: "Проект",
        name: "project",
        dataPath: "project.title",
        rowType: "wide",
      },
      {
        title: "Бонусні години",
        name: "bonus",
        dataPath: "hours",
        type: "decimal",
      },
      {
        title: "Сума бонуса",
        name: "amount",
        dataPath: "amount",
        type: "decimal",
      },
      {
        title: "Примітки",
        name: "comments",
        dataPath: "comments",
        rowType: "wide",
        width: 250,
      },
    ],
  }),
  methods: {
    getBonuses(...args) {
      return bonusesApi.getBonuses(args[0], args[1], args[2], args[3]);
    },
  },
};
</script>
